<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="full-width"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Alcances Acreditados</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? ``
            : ``
        "
      >
        <div class="col-12 mt-2">
          <app-table :id="tableId" :options="options" />
        </div>
      </form>
    </template>
    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
    </template>

  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { TableHelpersScopes } from "./TableHelpersScopes";
export default {
mixins: [FormMixin, ModalMixin, TableHelpersScopes],

  props: {
    tableId: String,
    accAppId: Number,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {},
      modalId: "modal-add-edit-modify-inf",
      options: {
        url: `/qualityMng/updateInformations/scopes_active?accAppId=${this.accAppId}`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  
  created() {
    let columns = [];
    if (["OCPR"].includes(this.activity)) columns = this.OCPR;
    else if (["CSGAS"].includes(this.activity)) columns = this.CSGAS;
    else if (["OCSG", "CSA"].includes(this.activity)) columns = this.OCSG;
    else if (["CSST"].includes(this.activity)) columns = this.CSST;
    else if (["CSEN"].includes(this.activity)) columns = this.CSEN;
    else if (["CSIA"].includes(this.activity)) columns = this.CSIA;
    else if (["OCPE"].includes(this.activity)) columns = this.OCPE;
    else if (["OINSP"].includes(this.activity)) columns = this.OINSP;
    else if (["OENY"].includes(this.activity)) columns = this.OENY;
    else if (["OICC"].includes(this.activity)) columns = this.OICC;
    else if (["OCLN"].includes(this.activity)) columns = this.OCLN;
    else if (["OEYC"].includes(this.activity)) columns = this.OEYC;
    else if (["OEAP"].includes(this.activity)) columns = this.OEAP;
    this.options.columns = [...columns];
  },
  methods: {
    submit() {},
    
  }
}
</script>

<style>

</style>
